import { render, staticRenderFns } from "./TransferUser.vue?vue&type=template&id=e0d9e9dc&scoped=true"
import script from "./TransferUser.vue?vue&type=script&lang=js"
export * from "./TransferUser.vue?vue&type=script&lang=js"
import style0 from "./TransferUser.vue?vue&type=style&index=0&id=e0d9e9dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0d9e9dc",
  null
  
)

export default component.exports